var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.83 51.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,9.36l-1.5,1.5A10,10,0,0,1,43,23l-5.54,5.54L34.7,25.8,39.49,21a1.56,1.56,0,1,0-2.21-2.21l-4.79,4.79-4.25-4.24L33,14.56a1.56,1.56,0,0,0-2.21-2.21L26,17.14,23.3,14.4l5.53-5.54A10,10,0,0,1,41,7.32l1.5-1.5L36.65,0H15.18L0,15.18V36.65l5.82,5.82L7.32,41A10,10,0,0,1,8.86,28.83L14.4,23.3,17.14,26l4.79-4.79a1.56,1.56,0,0,1,2.21,2.21l-4.79,4.79,4.24,4.25,4.79-4.79a1.56,1.56,0,0,1,2.21,2.21L25.8,34.7l2.74,2.73L23,43a10,10,0,0,1-12.14,1.54L9.36,46l5.82,5.82H36.65L51.83,36.65V15.18Z",
    fill: "#e20613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.38,27.7l-4.79,4.79-4.24-4.25,4.79-4.79a1.56,1.56,0,0,0-2.21-2.21L17.14,26,14.4,23.3,8.86,28.83A10,10,0,0,0,7.32,41l-1.5,1.5L9.36,46l1.5-1.5A10,10,0,0,0,23,43l5.54-5.54L25.8,34.7l4.79-4.79a1.56,1.56,0,0,0-2.21-2.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.47,5.82,41,7.32A10,10,0,0,0,28.83,8.86L23.3,14.4,26,17.14l4.79-4.79A1.56,1.56,0,0,1,33,14.56l-4.79,4.79,4.25,4.24,4.79-4.79A1.56,1.56,0,1,1,39.49,21L34.7,25.8l2.73,2.74L43,23a10,10,0,0,0,1.54-12.14L46,9.36Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryDisconnected);
export default __webpack_public_path__ + "static/media/battery-disconnected.e1459135a65c5354b978cb38908d773c.svg";
export { ForwardRef as ReactComponent };